import { ISanityBlockContent } from '@rbi-ctg/menu';
import { IPaymentMethod } from 'state/payment/types';

export interface IScanAndPayTextContent {
  header?: string | null;
  inactiveStateBody?: ISanityBlockContent[];
  activeStateBody?: ISanityBlockContent[];
  noPaymentMethodStateBody?: ISanityBlockContent[];
}

export enum ScanAndPayViews {
  NO_PAYMENT_METHOD = 'noPaymentMethod',
  INACTIVE = 'inactive',
  ACTIVE = 'active',
}
export interface ITHScanAndPayViewProps {
  addPaymentMethodButtonText?: string;
  currentView: ScanAndPayViews;
  isLoading: boolean;
  isUpdating: boolean;
  nonSelectedPaymentMethods: IPaymentMethod[];
  openAddPaymentMethodModal: () => void;
  scanAndPayTextContent: IScanAndPayTextContent;
  selectedPaymentMethod?: IPaymentMethod;
  toggleChecked: boolean;
  toggleScanAndPay: () => void;
  updateScanAndPayPaymentMethod: (scanAndPayPaymentMethodId: string) => void;
}

export interface IGetSortedValidPaymentMethods {
  paymentMethods: IPaymentMethod[];
  selectedPaymentMethodId: string;
}

export interface ISortedValidPaymentMethods {
  nonSelectedPaymentMethods: IPaymentMethod[];
  selectedPaymentMethod?: IPaymentMethod;
}
